var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4895_28866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.166 5.5C11.092 4.914 9.58302 4 8.16602 4C6.06602 4 4.16602 5.247 4.16602 9C4.16602 13.899 5.22202 17.41 6.83702 19.537C7.41002 20.293 8.80702 20.058 9.40402 19.301C9.80202 18.796 10.223 17.862 10.666 16.5C10.958 15.729 11.558 14.996 12.166 15C12.768 15 13.376 15.737 13.666 16.5C14.109 17.862 14.53 18.795 14.928 19.3C15.525 20.059 16.928 20.293 17.495 19.537C19.11 17.41 20.166 13.9 20.166 9C20.166 5.26 18.258 4 16.166 4C14.743 4 13.246 4.911 12.166 5.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16602 9.75C6.7518 9.75 6.41602 10.0858 6.41602 10.5C6.41602 10.9142 6.7518 11.25 7.16602 11.25V9.75ZM9.91602 9.75H7.16602V11.25H9.91602V9.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.166 9.75C14.7518 9.75 14.416 10.0858 14.416 10.5C14.416 10.9142 14.7518 11.25 15.166 11.25V9.75ZM19.666 9.75H15.166V11.25H19.666V9.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4895_28866",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.16602,
    y: 7.5,
    width: 6,
    height: 6,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.16602,
    y: 7.5,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-4-inside-1_4895_28866)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4895_28866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.166016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTreatment);
export default __webpack_public_path__ + "static/media/inTreatment.35c367433da53088d176cd1d31f32cb1.svg";
export { ForwardRef as ReactComponent };